import { startCase } from "lodash-es"
import React, { useCallback } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { useAuthorizationSimple } from "hooks/useAuthorizationStrict"
import { registrationModules } from "types/modules.types"
import CustomButton, { CustomButtonProps } from "../Atoms/CustomButton"
interface NewResourceButtonProps extends CustomButtonProps {
  module: registrationModules
  to?: string
}
const NewResourceButton = ({
  module,
  to,
  ...otherProps
}: NewResourceButtonProps) => {
  const canAddResource = useAuthorizationSimple(`ds_add_${module}`)
  const navigate = useNavigate()
  const location = useLocation()
  const handleClick = useCallback(() => {
    if (to) {
      navigate(to)
    } else {
      navigate(`${location.pathname}/new`)
    }
  }, [navigate, to, location])
  return (
    <CustomButton
      onClick={handleClick}
      text={startCase(module)}
      dark={otherProps.intent ? false : true}
      icon="plus"
      disabled={!canAddResource}
      {...otherProps}
    />
  )
}

export default NewResourceButton
